<template>
  <div class="account-listings-navigation">
    <vertical-navigation
      title="Listings"
      :links="links"/>
  </div>
</template>

<script>
import VerticalNavigation from '@/components/navigation/VerticalNavigation.vue'

export default {
  name: 'AccountListingsNavigation',
  components: {
    VerticalNavigation,
  },
  data() {
    return {
      selectedOption: null,
      links: [
        {
          type: 'subheading',
          name: 'All Listings',
        },
        {
          type: 'link',
          name: 'View All',
          to: '/account/listings',
        },
        {
          type: 'subheading',
          name: 'By Status',
        },
        {
          type: 'link',
          name: 'Active Listings',
          to: '/account/listings/approved',
        },
        {
          type: 'link',
          name: 'Draft Listings',
          to: '/account/listings/draft',
        },
        {
          type: 'link',
          name: 'Pending Listings',
          to: '/account/listings/pending',
        },
        {
          type: 'link',
          name: 'Completed Listings',
          to: '/account/listings/completed',
        },
        {
          type: 'link',
          name: 'Expired Listings',
          to: '/account/listings/expired',
        },
      ],
    }
  },
}
</script>
